import { STATUS_META } from "@/lib/api";

const COLORS = {
  amber: "bg-amber-100 text-amber-800 border-amber-200",
  emerald: "bg-emerald-100 text-emerald-800 border-emerald-200",
  red: "bg-red-100 text-red-800 border-red-200",
  slate: "bg-slate-100 text-slate-700 border-slate-200",
  blue: "bg-blue-100 text-blue-800 border-blue-200",
  orange: "bg-orange-100 text-orange-800 border-orange-200",
};

export default function StatusBadge({ value, testid }) {
  const meta = STATUS_META[value] || { label: value, color: "slate" };
  return (
    <span data-testid={testid} className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full border text-xs font-semibold ${COLORS[meta.color]}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current opacity-70" />
      {meta.label}
    </span>
  );
}

export function AssignmentPill({ assigned, needed }) {
  const full = assigned >= needed;
  const partial = assigned > 0 && !full;
  const color = full ? "bg-emerald-500" : partial ? "bg-blue-500" : "bg-slate-400";
  return (
    <span data-testid="assignment-pill" className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-white text-xs font-semibold ${color}`}>
      <span className="font-mono">{assigned}/{needed}</span>
      <span>{full ? "Fully Assigned" : partial ? "Partially Assigned" : "Finding Workers"}</span>
    </span>
  );
}
